import { authStore } from "../stores";
import { getApiUrl } from "../utils/apiUrl";

class DailyWheelApiService {
  getDailyWheelData = async (gameId: number, partnerId: number, currency: string) => {
    const response = await fetch(`${getApiUrl(process.env.REACT_APP_DAILY_WHEEL_URL!)}/api/v1/Wheels/Active?gameId=${gameId}&partnerId=${partnerId}&currency=${currency}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authStore.accessToken}`,
      },
    });
    const data = await response.json();
    return data.data;
  }

  getLastSpinData = async (wheelId: number) => {
    const response = await fetch(`${getApiUrl(process.env.REACT_APP_DAILY_WHEEL_URL!)}/api/v1/Wheels/LastSpin?WheelId=${wheelId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authStore.accessToken}`,
      },
    });
    const data = await response.json();
    return data.data;
  }

  spinWheel = async (gameId: number, spinId: number) => {
    const response = await fetch(`${getApiUrl(process.env.REACT_APP_DAILY_WHEEL_URL!)}/api/v1/Wheels/Spin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authStore.accessToken}`,
      },
      body: JSON.stringify({ gameId, spinId }),
    });
    if (!response.ok) throw new Error('Spin API failed');
    const data = await response.json();
    return data.data;
  }

  getUnusedSpins = async (wheelId: number) => {
    const response = await fetch(`${getApiUrl(process.env.REACT_APP_DAILY_WHEEL_URL!)}/api/v1/Wheels/Spins/Unused?WheelId=${wheelId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authStore.accessToken}`,
      },
    });
    const data = await response.json();
    return data.data || [];
  }

  getUserProgress = async (wheelId: number) => {
    try {
      const response = await fetch(`${getApiUrl(process.env.REACT_APP_DAILY_WHEEL_URL!)}/api/v1/Wheels/State?WheelId=${wheelId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authStore.accessToken}`,
        },
      });
      if (!response.ok) {
        console.error('Error fetching user progress:', response.statusText);
        return 0;
      }
      const data = await response.json();
      return data.data?.progress || 0;
    } catch (error) {
      console.error('Error fetching user progress:', error);
      return 0;
    }
  }
}

export const fortuneWheelApiService = new DailyWheelApiService();